import { render, staticRenderFns } from "./buy-quote.vue?vue&type=template&id=bf99b584&scoped=true&"
import script from "./buy-quote.vue?vue&type=script&lang=js&"
export * from "./buy-quote.vue?vue&type=script&lang=js&"
import style0 from "./buy-quote.vue?vue&type=style&index=0&id=bf99b584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf99b584",
  null
  
)

export default component.exports